/**
 * 선택 영역 숫자 집계 (합계/평균/건수/최소/최대)
 */

function parseNumber(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const s = String(value).replace(/,/g, '').replace(/%$/, '').trim();
  if (!s) return null;
  if (!/^-?\d+(\.\d+)?([eE][+-]?\d+)?$/.test(s)) return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

/**
 * @returns {{ count: number, numericCount: number, sum: number, avg: number, min: number, max: number, hasNumeric: boolean }|null}
 */
export function computeSelectionStats({ selectionRange, rows, columnIds, columns }) {
  if (!selectionRange || !rows?.length || !columnIds?.length) return null;

  const rowIds = rows.map((r) => r.id);
  const rMin = Math.min(rowIds.indexOf(selectionRange.startRowId), rowIds.indexOf(selectionRange.endRowId));
  const rMax = Math.max(rowIds.indexOf(selectionRange.startRowId), rowIds.indexOf(selectionRange.endRowId));
  const cMin = Math.min(columnIds.indexOf(selectionRange.startField), columnIds.indexOf(selectionRange.endField));
  const cMax = Math.max(columnIds.indexOf(selectionRange.startField), columnIds.indexOf(selectionRange.endField));
  if (rMin < 0 || cMin < 0) return null;

  let cellCount = 0;
  const nums = [];

  for (let rIdx = rMin; rIdx <= rMax; rIdx++) {
    const row = rows[rIdx];
    if (!row?.original) continue;
    for (let cIdx = cMin; cIdx <= cMax; cIdx++) {
      const field = columnIds[cIdx];
      if (field === 'mod' || field === 'rowNumber') continue;
      cellCount += 1;
      const raw = row.original[field];
      const n = parseNumber(raw);
      if (n != null) nums.push(n);
    }
  }

  if (cellCount === 0) return null;
  if (nums.length === 0) {
    return {
      count: cellCount,
      numericCount: 0,
      sum: 0,
      avg: 0,
      min: 0,
      max: 0,
      hasNumeric: false,
    };
  }

  const sum = nums.reduce((a, b) => a + b, 0);
  return {
    count: cellCount,
    numericCount: nums.length,
    sum,
    avg: sum / nums.length,
    min: Math.min(...nums),
    max: Math.max(...nums),
    hasNumeric: true,
  };
}

export function formatStatNumber(n, decimals = 2) {
  if (n == null || Number.isNaN(n)) return '-';
  if (Number.isInteger(n)) return n.toLocaleString('ko-KR');
  return n.toLocaleString('ko-KR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
}
